import { Component, Vue } from 'vue-property-decorator'
import { getSendMessageList, queryMessageTemplate, getAllClass, queryStudent, sendOutMessage, queryMessageClass, queryMessageStudent } from '@/api'
import { TagsViewModule } from '@/store/modules/tags-view'
@Component({ name: 'send-message-list-page' })
export default class SendMessageListPage extends Vue {
  private totalPage = 100;
  private currentPage = 1;
  private tableData = []
  private tableloading = false
  private sendDialogShow = false
  private temList: any = []
  private sendTemId = ''
  private acceptListStudent = []
  private acceptClasstype: any = 1
  private acceptListClass: any = []
  private classList: any = []
  private studentList: any = []
  private studentClassList: any = [{ val: 1, name: '普通班' }, { val: 2, name: '1v1' }, { val: 3, name: '论文班' }]
  private searchName: any = ''
  private loading = false
  created () {
    this.initPageData()
  }

  private async initPageData () {
    this.tableloading = true
    const param: any = { page: this.currentPage, limit: 20 }
    if (this.searchName) { param.studentName = this.searchName }
    const result: any = await getSendMessageList(param)
    const { allPage, currentPage, messageList } = result
    this.currentPage = currentPage
    this.totalPage = allPage
    this.tableData = messageList
    // this.classList = await getAllClass({})
    // this.classList = await queryMessageClass({ type: this.acceptClasstype })
    // this.studentList = await queryStudent({})
    this.temList = await queryMessageTemplate({})
    if (this.classList.length > 0) {
      // this.studentList = await queryMessageStudent({ type: this.acceptClasstype })
    }
    this.tableloading = false
  }

  private changeTemList () {
    this.studentList = []
    this.classList = []
    this.changeClasstype()
  }

  private async changeClasstype () {
    this.classList = await queryMessageClass({ templateId: this.sendTemId })
    this.changeListClass()
  }

  private async changeListClass () {
    this.acceptListStudent = []
    this.studentList = []
    const obj: any = {}
    if (this.acceptListClass) {
      obj.classId = this.acceptListClass
    }
    this.getStudentList(null)
    // this.studentList = await queryMessageStudent(obj)
  }

  private onPageChange () {
    this.initPageData()
  }

  private async onOkClick () {
    const param = {
      id: this.sendTemId,
      classId: this.acceptListClass,
      sellOrderId: this.acceptListStudent
    }
    await sendOutMessage(param)
    this.$message({ message: '发送成功', type: 'success' })
    this.sendDialogShow = false
    this.sendTemId = ''
    this.acceptListClass = []
    this.acceptListStudent = []
    this.initPageData()
  }

  private async onSearch () {
    this.currentPage = 1
    this.initPageData()
  }

  private async getClassList (query: any) {
    if (query !== '') {
      this.loading = true
      this.classList = await queryMessageClass({ name: query, templateId: this.sendTemId })
      this.loading = false
    } else {
      this.classList = []
    }
  }

  private async getStudentList (query: any) {
    // if (query !== '') {
    //   this.loading = true
    //   const obj: any = {
    //     name: query,
    //     templateId: this.sendTemId
    //   }
    //   if (this.acceptListClass) {
    //     obj.classId = this.acceptListClass
    //   }
    //   this.studentList = await queryMessageStudent(obj)
    //   this.loading = false
    // } else {
    //   this.studentList = []
    // }
    this.loading = true
    const obj: any = {
      name: query,
      templateId: this.sendTemId
    }
    if (this.acceptListClass) {
      obj.classId = this.acceptListClass
    }
    this.studentList = await queryMessageStudent(obj)
    this.loading = false
  }
}
